<template>
  <bd-date-picker
    :clearable="opts.clearable"
    :disabled="disabled"
    :editable="opts.editable"
    :format="opts.format"
    :shortcuts="opts.options.shortcuts"
    :disabled-date="opts.options.disabledDate"
    :placeholder="opts.placeholder"
    :start-placeholder="opts.startPlaceholder"
    :end-placeholder="opts.endPlaceholder"
    :readonly="opts.readonly"
    :range-separator="opts.separator"
    :size="opts.size"
    :unlink-panels="opts.splitPanels"
    :teleported="opts.transfer"
    :type="opts.type"
    v-model="dateRange"
    @change="_onChangeRange"
    style="width: 100%"
  >
  </bd-date-picker>
</template>

<script>
import { startOfDay, endOfDay } from 'date-fns'

export default {
  emits: ['on-change', 'input', 'update:modelValue', 'on-clear', 'on-clickoutside'],
  name: 'RangeDatePicker',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    begin: {
      type: [String, Number, Date],
      default() {
        return ''
      }
    },
    end: {
      type: [String, Number, Date],
      default() {
        return ''
      }
    },
    disabled: {
      type: [Boolean, String, Number],
      default: false
    }
  },
  watch: {
    begin: {
      deep: true,
      handler(nv, ov) {
        this._setDesDaterange()
      }
    },
    end: {
      deep: true,
      handler(nv, ov) {
        this._setDesDaterange()
      }
    }
  },
  data() {
    return {
      dateRange: [],
      opts: {
        type: 'daterange',
        format: 'YYYY-MM-DD',
        placement: 'bottom-start',
        placeholder: '选择开始和结束日期',
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        options: {},
        splitPanels: false,
        showWeekNumbers: false,
        // startDate: new Date(),
        confirm: false,
        open: null,
        size: 'default',
        // disabled: false,
        clearable: true,
        readonly: false,
        editable: false,
        transfer: false,
        elementId: '',
        separator: ' - ',
        capture: true,
        fixTimestamp: true,
        ...this.options
      }
    }
  },
  created() {
    this._setDesDaterange()
  },
  methods: {
    _setDesDaterange() {
      if (this.begin || this.end) {
        const begin = new Date(this.begin)
        const end = new Date(this.end)
        this.dateRange = [begin, end]
      } else {
        this.dateRange = ['', '']
      }
    },
    _formatRange(ranges) {
      if (!ranges) return ['', '']
      let start = ranges[0]
      let end = ranges[1]
      // 用于修正结束时间，修正成结束日的23:59:59
      if (this.opts.fixTimestamp) {
        start = start ? startOfDay(start).getTime() : ''
        end = end ? endOfDay(end).getTime() : ''
      }
      return [new Date(start).getTime(), new Date(end).getTime()]
    },

    _onChangeRange(daterange, type) {
      const ranges = this._formatRange(daterange, type)
      this.$emit('on-change', ranges[0] || '', ranges[1] || '')
    }
  }
}
</script>
